import { useCallback } from "react";

import { PendoProps } from "@impero-com/ui";
import { Column } from "@tanstack/react-table";

import { MultipleOptionFilterSelect } from "components/filters/MultipleOptionFilterSelect";

interface TSTValidMultipleOptionFilterSelectProps extends PendoProps {
    column: Column<any>;
    placeholder: string;
    options: Array<{
        label: string;
        value: string | number;
        customLabel?: React.ReactNode;
    }>;
    dropdownMatchSelectWidth?: number | boolean | undefined;
    value: null | string[] | number[];
    /** Optional custom setFilterValue handler. If not provided, uses column.setFilterValue */
    setFilterValue?: (value: (string | number)[] | null) => void;
    /** options are already in the correct order */
    presorted?: boolean;
}

/**
 * Selected values are kept even when they aren't among the current `options`
 * The filter stays applied — the table shows no matching rows — instead of silently resetting
 */
export function TSTValidMultipleOptionFilterSelect({
    column,
    placeholder,
    options,
    dropdownMatchSelectWidth,
    value,
    setFilterValue,
    presorted,
    "data-pendo": dataPendo,
}: TSTValidMultipleOptionFilterSelectProps) {
    const handleSetFilterValue = useCallback(
        (newValue: (string | number)[] | null) => {
            if (setFilterValue) {
                setFilterValue(newValue);
            } else {
                column.setFilterValue(newValue);
            }
        },
        [setFilterValue, column]
    );

    return (
        <MultipleOptionFilterSelect
            options={options}
            placeholder={placeholder}
            value={value ?? undefined}
            onChange={handleSetFilterValue}
            dropdownMatchSelectWidth={dropdownMatchSelectWidth}
            presorted={presorted}
            data-pendo={dataPendo}
        />
    );
}
